import styled, { css } from "styled-components";
import { Button as AntdButton } from "antd";

const ButtonTheme = {
  primary: css`
    background-color: #11a7d9;
    border-color: #11a7d9;
    color: #ffffff;

    &:hover,
    &:focus {
      background-color: rgb(7, 175, 231);
      color: #ffffff;
    }
  `,
  secondary: css`
    background-color: #ffffff;
    border-color: #11a7d9;
    color: #11a7d9;

    &.ant-btn:hover,
    &.ant-btn:focus {
      border-color: rgb(7, 175, 231);
      background-color: #ffffff;
      color: rgb(7, 175, 231);
    }
  `,
  upload: css`
    background-color: #f1f5f9;
    color: #334155;
    border-color: #cbd5e1;
    width: 141px;
    height: 33px;
    border-radius: 8.19px;
    padding: 8px 16px;
    text-transform: capitalize;

    &:hover,
    &:focus {
      border-color: #334155;
      background-color: #f1f5f9;
      color: #334155;
    }
  `,
  useGenerated: css`
    background-color: #ffffff;
    border-color: #ffffff;
    color: #11a7d9;
    text-transform: capitalize;

    &.ant-btn:focus {
      background-color: #ffffff;
      border-color: #ffffff;
      color: #11a7d9;
    }

    &.ant-btn:hover {
      border-color: #11a7d9;
      background-color: #ffffff;
      color: #11a7d9;
    }

    &.ant-btn:disabled {
      color: #d3d3d3;
      background-color: #ffffff;
      border-color: #ffffff;

      &:hover {
        background-color: #ffffff;
        border-color: #ffffff;
        color: #d3d3d3;
      }
    }
  `,
};

const size = {
  default: {
    width: "100%",
    height: "40px",
    borderRadius: "10px",
  },
  sm: {
    width: "220px",
  },
  modal: {
    width: "100%",
    height: "32.76px",
    borderRadius: "8.19px",
  },
};

export const StyledButton = styled(AntdButton)`
  border-radius: ${(props) =>
    size[props.width]?.borderRadius ?? size.default.borderRadius};
  width: ${(props) => size[props.width]?.width ?? size.default.width};
  height: ${(props) =>
    size[props.height]?.height ?? size.default.height} !important;

  text-transform: ${({ uppercase }) =>
    uppercase ? "uppercase" : "capitalize"} !important;

  border-style: solid;
  border-width: 1px;
  text-transform: uppercase;
  padding: 0;
  font-family: "Inter";
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  ${({ theme }) => {
    return ButtonTheme[theme] ?? ButtonTheme.primary;
  }}

  ${({ iconPosition }) => {
    return (
      iconPosition === "end" &&
      css`
        svg {
          order: 2;
        }
      `
    );
  }}

  p {
    margin: 0;
  }

  ${({ errorMessage }) =>
    errorMessage &&
    css`
      background-color: #dc2626;
      color: #fff;
      border-color: #dc2626 !important;
    `}

  &:disabled {
    cursor: not-allowed;
  }
`;

export const ReturnButton = styled.button`
  --blue: #11a7d9;

  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: var(--blue);
  cursor: pointer;
  background: transparent;
  border: none;

  display: flex;
  align-items: center;
  gap: 8px;

  p {
    margin: 0;
    text-decoration: underline;
    text-transform: capitalize;
  }

  &:disabled {
    color: #d3d3d3;
    cursor: not-allowed;
  }
`;
